"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApostilleAccount = void 0;
const symbol_sdk_1 = require("symbol-sdk");
const crypto_1 = require("crypto");
const fixPrivateKey = (privateKey) => {
    return (`0000000000000000000000000000000000000000000000000000000000000000${privateKey.replace(/^00/, '')}`)
        .slice(-64);
};
class ApostilleAccount {
    constructor(account, apiEndpoint) {
        if (account instanceof symbol_sdk_1.Account) {
            this.account = account;
            this.publicAccount = account.publicAccount;
        }
        else {
            this.publicAccount = account;
        }
        if (apiEndpoint) {
            this.apiEndpoint = apiEndpoint;
        }
    }
    getMultisigAccountInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.apiEndpoint) {
                try {
                    const multisigHttp = new symbol_sdk_1.MultisigHttp(this.apiEndpoint);
                    const multisigInfo = yield multisigHttp.getMultisigAccountInfo(this.publicAccount.address).toPromise();
                    this.multisigInfo = multisigInfo;
                }
                catch (err) {
                    if (err.message) {
                        const errMessage = JSON.parse(err.message);
                        if (errMessage.statusCode !== 404) {
                            throw Error('Multisig info error');
                        }
                    }
                    else {
                        throw Error('Multisig info api connection error');
                    }
                }
            }
            else {
                throw Error('API Endpoint is not undefined');
            }
        });
    }
    static create(seed, ownerAccount, apiEndpoint) {
        const { networkType } = ownerAccount.address;
        const hashFunc = crypto_1.createHash('sha256');
        hashFunc.update(seed);
        const hashedSeed = hashFunc.digest('hex');
        const signedSeed = ownerAccount.signData(hashedSeed);
        const privateKey = fixPrivateKey(signedSeed);
        const apostilleAccount = symbol_sdk_1.Account.createFromPrivateKey(privateKey, networkType);
        return new ApostilleAccount(apostilleAccount, apiEndpoint);
    }
    static createFromExistAccount(existAccount, apiEndpoint) {
        return new ApostilleAccount(existAccount, apiEndpoint);
    }
}
exports.ApostilleAccount = ApostilleAccount;
//# sourceMappingURL=ApostilleAccount.js.map